import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeBlue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.5 6.5C13.5 6.28906 13.4062 6.10156 13.2422 5.9375L7.24219 0.6875C7.10156 0.570312 6.91406 0.5 6.75 0.5C6.58594 0.5 6.39844 0.546875 6.23438 0.6875L0.234375 5.9375C0.0703125 6.10156 0 6.28906 0 6.5C0 6.92188 0.328125 7.25 0.75 7.25H1.5V11.75C1.5 12.1719 1.82812 12.5 2.25 12.5H4.5C4.89844 12.5 5.25 12.1719 5.25 11.75V9.125C5.25 8.9375 5.41406 8.75 5.625 8.75H7.875C8.0625 8.75 8.25 8.9375 8.25 9.125V11.75C8.25 12.1719 8.57812 12.5 9 12.5H11.2266C11.6484 12.5 11.9766 12.1719 11.9766 11.75V7.25H12.75C13.1484 7.25 13.4766 6.92188 13.5 6.5Z",
		fill: "#3D5AFE"
	})]
});
const ForwardRef = forwardRef(SvgHomeBlue);
export { ForwardRef as ReactComponent };
